import { updateDirectionInImageCustomVar } from "../../common/utils";
export const computeComboBoxItemImage = (itemUIModel, iconDirection, getImagePathCallback) => {
    const img = getImagePathCallback(itemUIModel, iconDirection);
    return img
        ? updateDirectionInImageCustomVar(img, iconDirection)
        : undefined;
};
const setComboBoxImagesForMap = (model, getImagePathCallback, itemImages) => {
    for (let index = 0; index < model.length; index++) {
        const itemUIModel = model[index];
        let computedImageModel;
        // startImgSrc
        if (itemUIModel.startImgSrc) {
            const computedImage = computeComboBoxItemImage(itemUIModel, "start", getImagePathCallback);
            computedImageModel = { start: computedImage };
        }
        // endImgSrc
        if (itemUIModel.endImgSrc) {
            const computedImage = computeComboBoxItemImage(itemUIModel, "end", getImagePathCallback);
            if (computedImageModel) {
                computedImageModel.end = computedImage;
            }
            else {
                computedImageModel = { end: computedImage };
            }
        }
        if (computedImageModel) {
            itemImages.set(itemUIModel.value, computedImageModel);
        }
        // Recursive phase
        if (itemUIModel.items != null) {
            setComboBoxImagesForMap(itemUIModel.items, getImagePathCallback, itemImages);
        }
    }
};
export const getComboBoxImages = (model, getImagePathCallback) => {
    if (!model) {
        return undefined;
    }
    const itemImages = new Map();
    setComboBoxImagesForMap(model, getImagePathCallback, itemImages);
    return itemImages;
};
